export default {
  /**邀请返佣首页 start */
  inviToReback: "Referral Program",
  accumuRewrds: "Bonus claimed",
  completedTranscation:
    "Claim extra 10USDT bonus when your friend finish at least one lot size perpetual contract",
  inviteQuick: "Just do it now./Go trade now.",
  currWeekRank: "weekly best seller",
  weekRank: "ranking",
  inviteNum: "numbers of your inviting friends",
  rebackAmount: "bonus amount",
  checkAllRanks: "Click to see more rankings",
  rebackRegu: "Bonus campaign are determined by specific campaign details",
  rebaRegu1:
    "During the trading rebate period, the referee can complete the account opening and trade any product, and the recommender can get a 25% commission (opening fee + closing fee) rebate. Note: The upper limit of a single customer's rebate is 500 USDT.",
  rebaRegu2:
    "During the recommendation activity, the referee completes more than 1 lot of perpetual contract transactions, and the referrer can get 10 USDT extra reward.",
  shareOnce: "Click to share",
  myBill: "My poster",
  shareToFace: "Share QR code",
  myShareQrCode: "My inviting QR code",
  sharOnceTitle: "Friends {phone} Send an invitation",
  sharOnceText: "Sign up & complete KYC to claim 5USDT bonus",
  shareActiveRegu: "Campaign Details",
  shareActiveTime:
    "Campaign period: Ongoing Eligible users: users who have an existing live account on BTCC",
  shareActiveSpire:
    "Rebate calculation period: Within 60 days after the invitee activates his/her BTCC account",
  shareActiveReward:
    "How to get rebates: After the referee activates his/her account and starts trading during the rebate calculation period, the referer will receive rebates (USDT) corresponding to the referee's trading volume.",
  shareActiveTip:
    "Invite a friend to trade and receive up to 500USDT rebates. The more you refer, the more rebates you will get. There is no limitation on the number of traders you can refer.",
  shareActiveAtten: "Terms & Conditions:",
  shareAtiveRegu1:
    "The referee must register for an account through the referrer's invitation link (or QR code), otherwise, it will not be regarded as a valid referral and the referrer will not receive any rebatOnly live account users are eligible to have their invitation links (or QR code).",
  shareAtiveRegu2:
    "Calculation of trading lots: The referer will get rebates on all of the referee's closed positions within 60 days after the referee's account is activated.",
  shareAtiveRegu3:
    "The rebates are calculated by calendar days and will be issued on working days (Monday to Friday). In the event of a holiday, the issuance of rebates will be postponed.",
  shareAtiveRegu4:
    "When there is a conflict in terms of the rebates between this campaign and other campaigns on the BTCC platform, other campaigns will take precedence over this refer-a-friend campaign.",
  shareAtiveRegu5:
    "BTCC reserves the right of final interpretation of these terms and the right to modify or terminate this campaign at any time without prior notice.",
  /**邀请返佣首页 end */

  /**邀请记录，返佣记录 start */
  inviteReocrd: "Invite",
  rebackRecord: "Rebates",
  invitedAccount: "Affiliate account",
  inviteTime: "Invited time",
  status: "Status",
  checkMore: "Click to see more",
  noRecord: "No available data",
  type: "Type",
  rebaNum: "Rebates (USDT)",
  activited: "Activated",
  notActive: "Not activated",
  /**邀请记录，返佣记录 end */
  /**排行榜 start */
  rankList: "Ranking",
  yourCurrWeekData: ",Your data this week",
  billboard: "Ranking",
  phone: "Cellphone number",
  cumulateReback: "Cumulative rebates",
  noData: "No data",
  /**排行榜 end */
  /**账户等级 start */
  account: "Account,",
  accountLevel: "Account level",
  miniAccount: "Mini account",
  stdAccount: "Standard account",
  vipAccount: "VIP account",
  stdFeeCut: "Rates drop by 6.66%",
  vipFeeCut: "Rates drop by 20%",
  currYouAre: "You are now",
  min: "Mini account",
  std: "Standard account",
  dia: "VIP account",
  superValueReco: "absolute bargain",
  invest: "Deposit（{unit}）",
  upgradeQuick: "Upgrade now",
  moreGradeProfit:
    "More rights would be released in the near future. Stay tuned",
  konwAccountLevel: "To learn more about account level",
  whatsAccountLevel: "What is the account level",
  thisIsAccountLevel:
    "Please contact the customer service to upgrade your account level. The more you deposit, the higher account level you become. And the higher account level you become, the lower fee you pay.",
  whichAccountLevel: "What are the account levels",
  accountLevelTypes:
    "Account levels are classified into mini, standard and VIP.",
  accountLevCondiAndProfit: "Account level conditions and benefits",
  feeRate: "Rate",
  level: "Levels",
  deposit: "Deposit",
  profit: "Rights and interests",
  mini: "Mini",
  noRights: "Unprivileged",
  standard: "Standard",
  stdFeeCuts: "Rates drop by 6.66%",
  vipFeeCuts: "Rates drop by 20%",
  moreCutToFees: "For specific rate deductions, please refer to the fund rate",
  example: "For example",
  exampleDetail:
    "“Taking the current price of BTC / USDT8000USDT as the calculation fee, the user has accumulated a total of 50 lots of BTC / USDT perpetual contracts as an example.”",
  noRecharge: "(No discount)",
  cut40: "(Straight down to 40USDT)",
  cut120: "(Drop to 120USDT)",
  minGradeAtten: "Upgrade now to enjoy more benefits！",
  stdGradeAtten: "Continue to upgrade to enjoy more benefits！",
  diaGradeAtten: "Trade now and enjoy more benefits！",
  /**账户等级 end */

  /**账户升级start */
  appliUpgrade: "Request an upgrade",
  accountNumber: "Account number",
  upgradeTo: "Upgrade to",
  submit: "Submit",
  upgradeNeedKnow: "Notice for level upgrading:",
  upgradeNeedKnow1:
    "1.Before upgrading, please ensure that there are no positions and pending orders in your account ",
  upgradeNeedKnow2:
    "2.The customer service will review and process the application by noon on the next working day after your application.",
  upgradeNeedKnow3:
    "3.After approval, log in again to enjoy a better investing experience",
  accountUpgrade: "Upgrade your account level",
  applyPno: "Application submitted successfully (application number：{pno})）",
  applyNumber: "Here is your BTCC account number:",
  applyFrom: "Apply from ",
  applyTo: " Your account level is now ",
  applyResTime:
    "The customer service will review and process the application by noon on the next working day after your application.",
  /**账户升级end */

  accountNoDot: " Account",
  bonus: "Bonus",
  cashBack: "Cash back",

  // 邀请返佣
  inviteHasInvitedUser: "Invited user(s)",
  inviteCumulativeBack: "Cumulative rebates (USDT)",
  inviteFriend: "Earn rebates through referrals",
  inviteFriendDesc:
    "Join BTCC with me & get a lucky draw entry to earn bonus every day. Reward of up to 1BTC awaits you. Register now with My referral code.",
  inviteMyInviteLink: "My referral link: ",
  inviteShareLink: "Share link",
  inviteCode: "My referral code: ",
  inviteCopy: "Copy",
  inviteNow: "Invite now",
  inviteToUser: "Invited user(s)",
  inviteMyReward: "My rebates",
  inviteUser: "User(s)",
  inviteRegisterTime: "Registration Time",
  inviteNoInvitePerson: "No one has been invited yet,",
  inviteStartInvite: "Start invitation",
  inviteReward: "Rebates (USDT)",
  inviteQRDesc: "Up to 500 USDT reward for BTCC registration",
  inviteQRJoin: "Scan to join",
  inviteCopySuccess: "Code copied successfully",
  inviteCopyError: "Copy fails",
  inviteFriendWin: "Invite friends to earn up to",
  inviteWinPercent: "25%",
  inviteBack: "commission rebate",
  inviteNoRecord: "No record",
  inviteSlogan:
    "Refer a friend to trade & get up to <strong>500USDT</strong> for free",

  vip权益全面升级: "Exclusive benefits",
  生效时间: "Effective from 2022/04/25 00:00:00 (UTC+8)  ",
  "您当前VIP等级,享受手续费折扣":
    "Your current VIP level: <span class='{level}'></span> with a <strong>{current}</strong> discount on transaction fees <br/> Upgrade your account to enjoy a <strong>{next}</strong> discount",
  VIP交易费率: "VIP Transaction Fees",
  VIP等级: "VIP Level",
  账户资金: "Total Net Asset Value (USDT)",
  币币交易手续费: "Crypto Conversion Fees",
  合约交易手续费: "Futures Transaction Fees",
  前往充值: "Upgrade Account Now",
  前往充币: "Deposit Now",
  充提币手续费: "Deposit and Withdrawal Fees",
  币种: "Crypto",
  充币费用: "Deposit Fees",
  提币费用: "Withdrawal Fees",
  最小提币数量: "Minimum Withdrawal",
  最小充币数量: "Minimum Deposit",
  折扣: "{amount} Discount",
  说明: "Terms & Conditions: ",
  说明1:
    "VIP levels of the BTCC VIP programme are upgraded automatically, according to the requirements listed. Below is the VIP level upgrade time:",
  说明2:
    " In this new VIP programme, users will not be downgraded to a lower level once upgraded.",
  说明3:
    "Fees for opening and closing each position will be charged according to the user's current VIP level.",
  说明4:
    "There is no differentiation between the trading fees of a taker or a maker on BTCC. ",
  说明5:
    "Please note the above rules are effective from 10 January 2023 at 07:00 in the morning (UTC+0).",
  其他货币: "Other coins",

  // 累计充值活动
  新手专享: "Exclusive for New Users",
  新手专享豪礼送: "Exclusive Bonus for New Users",
  注册成功后等级赠金奖励:
    "Meet the deposit targets within {day} days after successful registration at BTCC, and you can enjoy the bonus of the corresponding target levels.",
  立即报名: "Login to participate",
  如何领取奖励: "How to Get Bonus",
  如何领取奖励第一步: "Step 1: Sign up for a BTCC account",
  如何领取奖励第二步: "Step 2: Make deposits to meet the requirements",
  如何领取奖励第三步: "Step 3: Bonus will be credited to your account automatically",
  立即买币: "Buy crypto",
  立即充币: "Deposit crypto",
  储值福利进度: "My Bonus Progress ({coin} Deposits)",
  充值升级提示:
    "Deposit more within {day} days after registration to earn up to 17,500USDT bonus.",
  活动举例: "Example",
  有效充值: "Deposit",
  累计返利: "Cumulative rebates (USDT)",
  活动规则及条款: "Campaign Rules & Terms",
  活动版权:
    "BTCC reserves the right of final interpretation of the campaign. If you have any questions, please contact our ",
  请联系客服: "customer service team",
  报名成功: "Registration Success ",
  充币提示:
    "You can now deposit the following coins. Tap on each of the coins to check your deposit progress.",
  我已了解: "Got it",
  充值升级下一级:
    "You have received <strong>{bonus}</strong> bonus.<br />Deposit a cumulative of <strong>{amount}</strong> to unlock the next level of reward!",
  不符合新手报名条件: "Sorry, you are not eligible anymore",
  前往福利中心参与其他活动:
    "Please visit our Campaigns page for other promotions and events. ",

  我的赠金记录: "My Bonus History",
  福利中心: "Free Bonus",
  立即登录: "Login",
  免费注册: "Register for free",
  "参与活动": "Join our campaign",
  "立即参与": "Participate now",
  "继续充值": "Deposit now",
  captcha_desc: "Slide to complete the image",
  当前等级: "Your current level:",
  当前: "",
  参数: " ",
  兑换手续费减免: "Conversion fee discount",
  提币手续费减免: "Withdrawal fee discount",
  月总成交量USD: "30d Trade Volume(USD)",
  账户资产USD: "Total account assets(USD)",
  账户资产: "Total account assets:",
  继续升级: "Upgrade your account to enjoy a {amount} discount on trading fees.",
  gotIt: "ok",
  我的30日成交量: "30d Trade Volume",
  最近30天成交的交易合约: "This refers to your futures contract trading volume of the last 30 days, calculated in USD.",
  我的资产: "Total account assets",
  昨日账户资产: "This refers to the value of your account assets (including all cryptos)*, calculated in USD.<span>*Updated every day at 08:00 (UTC+0)</span>",
  "title": "10-Day Trading Challenge",
  "solgen": "Complete challenges to open Mystery Boxes. Get up to 210 USDT in bonuses and enjoy FREE trading fees!",
  "super": "Super Mystery Box",
  "super_award": "Get a random bonus of {min}-{max} USDT",
  "supper_task": "Open a random of 7 Mystery Boxes to be eligible for the Super Mystery Box",
  "supper_tip": "Please complete the daily challenges to open 7 Mystery Boxes first.",
  "supper_open": "Open Now",
  "day": "Progress: Day {day}",
  "award_fee": "A random trading fee rebate of {min}-{max}%",
  "award_bouns": "A random bonus of {min}-{max} USDT",
  "task_complete": "Completed <span>{reach}/{total}</span>",
  "contract_task": "Trading Challenges",
  "task_need": "Complete <span>{num}</span> trade(s)",
  "get_award_fee": "You've received: A {amount}% trading fee rebate",
  "get_award_bouns": "You've received: A {amount} USDT bonus",
  "award_overdue": "Expired",
  "award_hasget": "Reward received",
  "award_toget": "Open box now",
  "task_nostart": "Not available",
  "task_ongoing": "Challenge in progress",
  "task_rules": "Campaign Rules",
  "task_rules_content1": "1. Eligibility: Only users who are at the VIP0 level after 23 December 2022 at 02:00:00 (UTC+0) AND who upgrade their VIP levels to VIP1 or above after the date and time mentioned. Once users meet these two requirements, they will be automatically registered for this campaign.",
  "task_rules_content1_desc": "Users who were already upgraded from VIP0 to VIP1-VIP9 before 23 December 2022 at 02:00:00 (UTC+0) are not eligible for this campaign.",
  "task_rules_content2": "2. The campaign begins once users upgrade their VIP levels to VIP1 or above. The information on this campaign page is updated daily at 21:00 (UTC+0).",
  "task_rules_content3": "3. To open the Mystery Box of the day, users must complete the day's trading challenge. If users fail to complete the day's trading challenge before 21:00 (UTC+0) every day, the Mystery Box of the day will expire.The number of trades completed during the day will be automatically reset after 21:00 (UTC+0) every day, and the next day's trading challenges will be available to users afterwards.",
  "task_rules_content4": "4. There are two types of rewards in the Mystery Boxes: trading fee rebates and bonuses.Trading fee rebates: They are tradable and withdrawable and will be issued to the user's account automatically once the Mystery Boxes are opened. Bonuses: They can only be used to cover trading fees. The fee coverage rate depends on the user's VIP level.",
  "task_rules_content5": "5. The trading fee rebate is only applicable to the number of trades required to be completed for the day. If users complete more trades than required, those trades will not be counted towards the rebate in this campaign.",
  "task_rules_content6": "6. To be eligible for the Super Mystery Box, users must first complete any 7 days of trading challenges and open 7 mystery boxes. If users do not complete the challenges before the campaign ends, users will not be able to open the Super Mystery Box.",
  "task_rules_content7": "7. The rewards in the Mystery Boxes are given on a random basis.",
  "task_rules_content8": "8. Rewards are automatically issued to the users' accounts after opening the Mystery Boxes. If you do not receive the rewards in time, please get in touch with our customer support via Live Chat for assistance.",
  "task_rules_content9": "9. If the user's account is restricted due to unusual activity during the campaign, the user will not be eligible to open the Mystery Boxes.",
  "task_rules_content10": "10. The trades counted in this campaign include the opening, closing, and liquidation of USDT-margined and coin-margined positions. ",
  "task_rules_content11": "Terms and Conditions",
  "task_rules_content12": "1. BTCC reserves the right to immediately disqualify users who show signs of fraudulent behaviours, such as maliciously registering accounts in batches and manipulating transactions to obtain rewards during the campaign.",
  "task_rules_content13": "2. BTCC reserves the right to cancel or modify the rules and terms of the campaign at its own discretion without prior notice.",
  "task_rules_content14": "3. BTCC reserves the right of final interpretation of the campaign. If you have any questions, please contact our customer service team for assistance.",
  "complete_task": "Completed <span>{num}</span> trades",
  "no_standard": "Challenge not completed—only completed {num} trade(s)."
};



// WEBPACK FOOTER //
// ./src/locales/en-US.js